import React from "react";
import { ColumnFormatter } from "react-bootstrap-table-next";

export const ConfidentialColumnFormatter: ColumnFormatter<any, any, string> = (cell) => (
  <span className="svg-icon svg-icon-xl svg-icon-primary">
    {cell && <i className="ki ki-hide icon-md text-primary" />}
  </span>
);
